export default {
  idtName: {
    UC_CMD_PT: 'CHAVE MÓVEL DIGITAL',
  },
  idtIdentifier: {
    UC_CMD_PT: 'Phone number: {mobileNumber} ',
  },
  welcome: {
    title: 'Bem-vindo ao serviço de Assinaturas Qualificadas da WalliD',
    text1:
      'Este documento requer uma assinatura qualificada utilizando a Chave Móvel Digital (CMD).',
    text2:
      'Nos próximos passos poderá autenticar-se com a sua CMD e assinar o documento com o seu certificado, assegurando uma assinatura legal e qualificada.',
    terms: [
      'Por favor aceite',
      'os termos e condições da CMD AMA',
      'e da',
      'WalliD',
    ],
  },
  textNoCMD: [
    'Não tem o PIN de assinatura ativo?',
    'Active em autenticação.gov',
  ],
  identity: {
    title: 'Assine este documento com a sua Chave Móvel Digital',
    text:
      'Por favor insira o seu número de telemóvel e o seu PIN associados à sua CMD. Irá receber um SMS ou uma notificação da APP autenticação.gov com o código de verificação para completar a assinatura.',
    numberLabel: ['Número de telemóvel:', 'Insira o seu número de telemóvel'],
    placeholder: 'Selecione uma identidade válida',
    pinLabel: ['PIN:', 'Insira o seu pin'],
  },
  authentication: {
    title: 'Validação da autenticação',
    text:
      'Por favor insira o código enviado para si por SMS ou através da APP Autenticação.gov nos próximos 5 minutos, para completar a assinatura.',
    textStored:
      "Please provide the code sent to your phone by AMA's CMD within the next 5 minutes and complete the signature with your CMD already stored in your MyWalliD wallet.",
    codeLabel: ['Código de autenticação:', 'Insira o código'],
  },
  successfull: {
    title: 'O seu documento foi assinado com sucesso!',
    text1: [
      'O ID do envelope',
      'que contem os documentos:',
      'foi assinado com sucesso.',
      'A assinatura qualificada da CMD foi integrada no documento e pode agora ser verificada.',
    ],
    cmdStoreText: [
      'Deseja guardar os seus dados da CMD para futuras assinaturas?',
      'Guarde a sua CMD na carteira MyWalliD',
      '(extensão browser) e assine documentos de forma instantânea.',
    ],
    cmdStoreBtn: 'Guardar CMD na carteira MyWalliD',
  },
  errors: {
    invalidCertificates:
      "A sua CMD não tem certificados válidos associados ou eles não estão corretamente armazenados na sua CMD.",
    noCMD:
      'O seu número de telemóvel não tem uma CMD ativa associada ou o PIN de assinatura não está ativo',
    incorrectPIN: 'O PIN não está correto',
    numberRequired: 'O número de telemóvel é obrigatório',
    pinRequired: 'O PIN é obrigatório',
    incorrectCode: 'O código de autenticação não está correto',
    codeRequired: 'O código de autenticação é obrigatório',
    expired:
      'A sua sessão foi terminada. Por favor volte ao email para iniciar o processo de assinatura novamente.',
    // failedsignature:
    //   'Ocorreu um problema com a sua sessão. Por favor contacte-nos.',
    failedsignature: [
      'Não foi possível assinar este documento. Por favor ',
      ' contacte-nos.',
    ],

    notPDF:
      'não é um PDF! Não é possível fazer uma assinatura qualificada em documentos neste formato. Por favor contacte o remetente.',
    alreadySigned:
      'Todos os documentos dentro deste envelope já foram assinados. Por favor atualize a página.',

    expiredOtp:
      'Código de autenticação expirado. Por favor volte ao passo anterior e repita o processo.',
  },
  button: {
    next: 'Avançar',
    back: 'Voltar',
    authenticate: 'Autenticar',
    sign: 'Assinar documento',
    done: 'Feito',
  },
};
